import React from 'react';
import { CartesianChartSeriesType } from '@mui/x-charts/internals';
import { UseAxisTooltipReturnValue } from '@mui/x-charts/ChartsTooltip';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';

type Props = Pick<
    UseAxisTooltipReturnValue<CartesianChartSeriesType, number>,
    'axisFormattedValue' | 'identifier' | 'seriesItems'
>;

const CustomTooltipContent = React.forwardRef<HTMLDivElement, Props>(
    function CustomTooltipContent(props, ref) {
        return (
            <Box ref={ref} sx={{ p: 1.5 }}>
                <Stack direction="row" alignItems="center">
                    {props.seriesItems.map(series => (
                        <Stack
                            key={series.seriesId}
                            direction="row"
                            alignItems="center"
                        >
                            <div
                                style={{
                                    width: 11,
                                    height: 11,
                                    borderRadius: '50%',
                                    backgroundColor: series.color,
                                }}
                            />
                            <Typography sx={{ ml: 1 }} fontWeight="light">
                                {series.formattedValue}
                            </Typography>
                            <Typography sx={{ ml: 1 }}>
                                {series.formattedLabel}
                            </Typography>
                        </Stack>
                    ))}
                </Stack>
            </Box>
        );
    }
);

export default CustomTooltipContent;
